
import Vue from 'vue'

export default Vue.extend({
  seo: {
    title: 'ImageMeta EXIF Metadata Project | Aaron Cunliffe',
    description: 'ImageMeta is an image metadata and EXIF extraction project by Aaron Cunliffe, including an npm package and Vue demonstration site.'
  }
})
